"use client"

import * as React from "react"
import { useLocation, useNavigate } from "react-router"

import { useExamRole } from "@/contexts/exam-role-context"
import {
  EXAM_MANAGEMENT_MY_EXAMS_PATH,
  isExamManagementAdminOnlyPath,
} from "@/lib/exam-management-student-routes"

/** Redirect Student persona away from admin Exam Management routes. */
export function ExamManagementStudentRouteGuard() {
  const { role } = useExamRole()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (role !== "Student") return
    if (!isExamManagementAdminOnlyPath(pathname)) return
    navigate(EXAM_MANAGEMENT_MY_EXAMS_PATH, { replace: true })
  }, [role, pathname, navigate])

  return null
}
